import {
  ACCOUNT_FIELDS,
  APPLICATION_FIELDS,
  CONTACT_FIELDS,
} from './serverFieldMappings';

export default {
  CONTACT: {
    fields: [CONTACT_FIELDS.NAME_1, CONTACT_FIELDS.NAME_2]
  },
  ACCOUNT: {
    fields: [ACCOUNT_FIELDS.NAME_1]
  },
  APPLICATION: {
    fields: [APPLICATION_FIELDS.LOAN_USE, APPLICATION_FIELDS.NOTES]
  },
};
